<script setup lang="ts">
import { ref, Ref, defineEmits, defineProps, inject } from 'vue'
import { useEventStore } from '@/store/event'

const store = useEventStore()

const props = defineProps({
  index: {
    type: Number,
    required: true
  }
})

const serverErrors = inject<Ref<any>>('serverErrors')

const emit = defineEmits(['remove'])

const removeFromList = () => {
  store.getContent('notifications').visible = false
  emit('remove', store.getContent('notifications'))
}

const getError = (field: string) => {
  if (serverErrors?.value && serverErrors.value['content.' + props.index + '.data.' + field]) {
    return serverErrors.value['content.' + props.index + '.data.' + field][0]
  }
  return null
}
</script>

<template>
  <div class="card w-full bg-base-100   mt-4">
    <div class="card-body">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <div class="handle cursor-pointer mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 24 24">
              <title>drag-horizontal</title>
              <path
                d="M3,15V13H5V15H3M3,11V9H5V11H3M7,15V13H9V15H7M7,11V9H9V11H7M11,15V13H13V15H11M11,11V9H13V11H11M15,15V13H17V15H15M15,11V9H17V11H15M19,15V13H21V15H19M19,11V9H21V11H19Z" />
            </svg>
          </div>
          <h2 class="card-title">Hinweise</h2>
        </div>
        <div class="tooltip" data-tip="Inhaltselement ausblenden">
          <button @click.prevent="removeFromList">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 24 24"><title>eye-off</title><path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" /></svg>
          </button>
        </div>
      </div>
      <div>
        <label class="form-control w-full">
          <div class="label">
            <span class="label-text">Titel*</span>
          </div>

          <input type="text" v-model="store.getContent('notifications').data.title"
            class="input input-bordered input-sm w-full" :class="{ 'input-error': getError('title') }" required>

          <div class="label" v-if="getError('title')">
            <span class="label-text-alt text-error">
                <strong>{{ getError('title') }}</strong>
            </span>
          </div>
        </label>
      </div>
      <div class="mt-4">
        <div v-for="(item, listIndex) in store.getContent('notifications').data.list" :key="listIndex"
          class="flex flex-col mb-6 sm:mb-2">
           <div class="flex items-center justify-between">
            <div class="flex flex-wrap mr-2 w-[95%] justify-between">
              <textarea v-model="item.text" class="textarea textarea-bordered textarea-sm w-full" :class="{ 'textarea-error': getError('list.' + listIndex + '.text') }" rows="4"></textarea>
            </div>
            <button class=" btn btn-sm btn-square text-white"
                @click.prevent="() => store.getContent('notifications').data.list.splice(listIndex, 1)">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 fill-error" viewBox="0 0 24 24"><title>delete-outline</title><path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" /></svg>
            </button>
          </div>
          <div class="label" v-if="getError('list.' + listIndex + '.text')">
            <span class="label-text-alt text-error">
                <strong>{{ getError('list.' + listIndex + '.text') }}</strong>
            </span>
          </div>
        </div>
        <button class="btn btn-block btn-success btn-sm text-white" @click.prevent="() => store.getContent('notifications').data.list.push({ text: '' })">+ Notiz hinzufügen</button>
      </div>
    </div>
  </div>
</template>
